/* AURELYS - Fiche produit : galerie, variantes, cadeau automatique */
(function () {
  'use strict';

  var root = document.querySelector('.aur-hero');
  if (!root) return;

  var GIFT_VID = parseInt(root.dataset.aurGiftVid, 10) || null;
  var TRIGGER_PID = parseInt(root.dataset.aurTriggerPid, 10) || null;
  var CART_URL = root.dataset.aurCartUrl || '/cart';

  var slides = root.querySelectorAll('[data-aur-slide]');
  var thumbs = root.querySelectorAll('[data-aur-thumb]');
  var stage = root.querySelector('[data-aur-stage]');

  function showSlide(i) {
    slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    if (window.matchMedia('(max-width: 989px)').matches && slides[i] && stage) {
      stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showSlide(parseInt(t.dataset.aurThumb, 10));
    });
  });

  if (stage) {
    var scrollTimer;
    stage.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(stage.scrollLeft / stage.clientWidth);
        thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      }, 90);
    }, { passive: true });
  }

  var variantsEl = root.querySelector('[data-aur-variants]');
  var variantInput = root.querySelector('[data-aur-variant]');
  var selects = root.querySelectorAll('[data-aur-option-index]');
  var priceNow = root.querySelector('.aur-price__now');
  var atc = root.querySelector('[data-aur-atc]');
  var atcText = root.querySelector('[data-aur-atc-text]');

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' EUR';
    }
  }

  if (variantsEl && variantInput && selects.length) {
    var variants = JSON.parse(variantsEl.textContent);
    var onChange = function () {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;
      variantInput.value = match.id;
      if (priceNow) priceNow.textContent = formatMoney(match.price);
      if (atc && atcText) {
        atc.disabled = !match.available;
        atcText.textContent = match.available ? 'Ajouter au panier' : 'Epuise';
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', onChange); });
  }

  var form = document.getElementById('aur-product-form');

  if (form && atc && variantInput) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      atc.classList.add('is-loading');

      var items = [{ id: parseInt(variantInput.value, 10), quantity: 1 }];
      if (GIFT_VID) {
        items.push({
          id: GIFT_VID,
          quantity: 1,
          properties: { _cadeau: 'Offert avec la Creme Anti-Rides' }
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        })
        .then(function () {
          window.location.href = CART_URL;
        })
        .catch(function () {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [items[0]] })
          }).then(function () {
            window.location.href = CART_URL;
          });
        })
        .finally(function () {
          atc.classList.remove('is-loading');
        });
    });
  }

  function updateCart(id, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: qty })
    }).then(function () { window.location.reload(); });
  }

  if (GIFT_VID && TRIGGER_PID && window.location.pathname.indexOf('/cart') === 0) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasTrigger = cart.items.some(function (i) { return i.product_id === TRIGGER_PID; });
        var giftLine = cart.items.filter(function (i) { return i.variant_id === GIFT_VID; })[0];
        if (!giftLine) return;
        if (!hasTrigger) return updateCart(GIFT_VID, 0);
        if (giftLine.quantity > 1) return updateCart(GIFT_VID, 1);
      })
      .catch(function () {});
  }
})();
